module.exports = __webpack_public_path__ + "img/login-bg.35e37c99.png";